import type { Auth, OAuthCredential, User } from 'firebase/auth'
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { useStorage } from '@vueuse/core'

export type AuthUser = User & {
  stsTokenManager: {
    accessToken: string
    refreshToken: string
    expirationTimer: number
  }
}

export default function () {
  const { $auth } = useNuxtApp()
  const $authTyped = $auth as Auth

  const firebaseUser = useState<User | null>('firebase:user', () => null)
  const [isLoading, toggleLoading] = useToggle(!firebaseUser.value)
  $authTyped?.onAuthStateChanged((user) => {
    firebaseUser.value = user
    toggleLoading(false)
  })

  const logIn = async (): Promise<OAuthCredential | false> => {
    if (!$authTyped)
      return false

    try {
      const result = await signInWithPopup($authTyped, new GoogleAuthProvider())
      sendGTMEvent({ event: 'user-login' })
      return GoogleAuthProvider.credentialFromResult(result) as OAuthCredential
    }
    catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)
    }

    return false
  }

  const logOut = async (): Promise<void> => {
    if (!$authTyped)
      return

    const isLoggedIn = useStorage('is_logged_in', false)

    $authTyped.signOut()
    isLoggedIn.value = false

    if (!firebaseUser.value)
      return

    firebaseUser.value = null
    useUser().value = null
  }

  return {
    firebaseUser,
    isLoading,
    logIn,
    logOut,
  }
}
